import React from 'react';
import { formatISK, parseISK } from '@/utils/formatISK';

/**
 * One money field for the whole app (Phase 1 #8).
 *
 * Shows Icelandic thousands dots WHILE TYPING — 276000 reads as 276.000 —
 * and hands the parent a plain integer. A contractor typing a six-figure
 * number into a bare <input type="number"> cannot see whether he hit
 * 27.600 or 276.000; that is the bug this removes.
 */
export const MoneyInput = ({
  value,
  onChange,
  placeholder = '0',
  className = '',
  testId,
  readOnly = false,
  allowNegative = false,
  ...rest
}) => {
  const [text, setText] = React.useState(
    value === '' || value === null || value === undefined ? '' : formatISK(value),
  );
  const focused = React.useRef(false);

  React.useEffect(() => {
    if (focused.current) return;
    setText(value === '' || value === null || value === undefined ? '' : formatISK(value));
  }, [value]);

  const commit = (raw) => {
    const negative = allowNegative && String(raw).trim().startsWith('-');
    const digits = String(raw).replace(/[^\d]/g, '');
    if (!digits) {
      setText(negative ? '-' : '');
      onChange('');
      return;
    }
    const n = parseISK(digits) * (negative ? -1 : 1);
    setText((negative ? '-' : '') + formatISK(Math.abs(n)));
    onChange(n);
  };

  return (
    <input
      type="text"
      inputMode="numeric"
      className={`font-mono ${className}`}
      placeholder={placeholder}
      value={text}
      readOnly={readOnly}
      onFocus={() => { focused.current = true; }}
      onBlur={() => { focused.current = false; }}
      onChange={(e) => commit(e.target.value)}
      data-testid={testId}
      {...rest}
    />
  );
};

export default MoneyInput;
